import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TariffType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/enums/tariff/tariff-type.enum';
import { useTranslation } from 'react-i18next';

interface TariffTypeFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const TariffTypeFilterController = ({
  onChange,
  selectedItemIds,
}: TariffTypeFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const tariffTypeList = Object.values(TariffType).map((status) => ({
    key: status,
    value: t(`delmonicos-shared-sdk.enums-tariff-type.${status}`),
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="currency-euro-circle"
        text={t('delmonicos-shared-sdk.outputs-tariff.type')}
      />
      <FilterToggle
        initialSelectedItemIds={selectedItemIds}
        items={tariffTypeList}
        onChange={onChange}
      />
    </Stack>
  );
};
